import { Button, Col, Image, Row } from 'react-bootstrap';
import UniversalInput from 'components/global/UniversalInput';
import { $form } from 'signals/global.signals';
import { handleSubmitAcceptInvite } from 'components/views/PublicAcceptInvite/_helpers/publicAcceptInvite.events';
import { useParams } from 'react-router-dom';
import SecondaryLayout from 'components/global/SecondaryLayout';
import SimpleCard from 'components/global/SimpleCard';
import useEffectAsync from 'utils/useEffectAsync';
import fetchAndSetInviteData from 'components/views/PublicAcceptInvite/_helpers/publicAcceptInvite.resolvers';

const PublicAcceptInvite = () => {
  const { token } = useParams();
  useEffectAsync(async () => {
    if (token) {
      await fetchAndSetInviteData(token);
    }
  }, [token]);
  return (
    <SecondaryLayout>
      <SimpleCard className="text-white bg-gray-800 px-40">
        <Row className="my-32 border-bottom border-gray-700 pb-16">
          <Col xs={12} className="text-center">
            <Image
              className="nav-logo mb-16"
              src="/images/logo-lg.png"
              height="100%"
            />
            <h4 className="text-center">Accept Invite</h4>
            <h5 className="text-center">Provide your information to accept the invite</h5>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <UniversalInput
              label="First Name"
              name="firstName"
              placeholder="First Name"
              className="mb-24"
            />
          </Col>
          <Col lg={12}>
            <UniversalInput
              label="Last Name"
              name="lastName"
              placeholder="Last Name"
              className="mb-24"
            />
          </Col>
          <Col lg={12}>
            <UniversalInput
              name="email"
              placeholder="Email"
              label="Email"
              className="mb-24"
              disabled
            />
          </Col>
          <Col lg={12}>
            <UniversalInput
              type="password"
              name="password"
              placeholder="Password"
              label="Password"
              className="mb-24"
            />
            <Col lg={12}>
              <UniversalInput
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                label="Confirm Password"
                className="mb-48"
              />
            </Col>
          </Col>
        </Row>
        <Button
          onClick={() => handleSubmitAcceptInvite(token)}
          disabled={!$form.value.email || !$form.value.password || !$form.value.confirmPassword}
          variant="primary"
          className="w-100 py-8"
        >
          Sign Up
        </Button>

      </SimpleCard>
    </SecondaryLayout>
  );
};

export default PublicAcceptInvite;
